export const CELL_CLASS = 'compare-text-value';
